import { createAction, props } from '@ngrx/store';
import { Ciudad } from 'src/app/pago/models/Ciudad.model';
import { Departamento } from 'src/app/pago/models/Departamento.model';
import { Maestro } from 'src/app/pago/models/Maestro.model';

export const getTiposDeDocumento = createAction(
  '[Maestros] Cargar tipos de documento'
);

export const saveTiposDeDocumento = createAction(
  '[Maestros] Guardar tipos de documento',
  props<{ tiposDeDocumento: Maestro[] }>()
);

export const getCiudades = createAction('[Maestros] Cargar ciudades');

export const saveCiudades = createAction(
  '[Maestros] Guardar ciudades',
  props<{ ciudades: Ciudad[] }>()
);

export const getDepartamentos = createAction('[Maestros] Cargar departamentos');

export const saveDepartamentos = createAction(
  '[Maestros] Guardar departamentos',
  props<{ departamentos: Departamento[] }>()
);
